import * as React from 'react';

import { LoaderContainer, StyledCircularProgress } from './styles';
import { LoaderProps } from './types';

const Loader: React.FC<LoaderProps> = ({ isFullScreen = false, size }) => {
  return (
    <LoaderContainer isFullScreen={isFullScreen}>
      <StyledCircularProgress size={size} />
    </LoaderContainer>
  );
};

export default Loader;
